import React from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    paper: {
      width: 400
    },
    pspan: {
        display: "block"
    }
  });

class MsgDialog extends React.Component {

    render() {
        const { classes } = this.props;

        let _body = [];
        _body = this.props.body.split("<br>");

        return (
            <div>
                <Dialog
                    classes={{paper: classes.paper}}
                    disableBackdropClick={true}
                    disableEscapeKeyDown={true}
                    open={this.props.open}
                    onClose={this.props.close}


                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">

                    <DialogTitle id="alert-dialog-title">{this.props.header}</DialogTitle>

                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <span className={classes.pspan}>{_body[0]}</span>
                            <span className={classes.pspan}>{_body[1]}</span>
                            <span className={classes.pspan}>{_body[2]}</span>
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={this.props.handleBtn2} color="primary" autoFocus>
                            {this.props.btn2}
                        </Button>
                        <Button onClick={this.props.handleBtn1} color="primary">
                            {this.props.btn1}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default withStyles(styles)(MsgDialog);


// WEBPACK FOOTER //
// ./src/components/MsgDialog/index.js